import { createFileRoute, redirect } from '@tanstack/react-router'
import { articlesQueryOptions } from '../../../hooks/useArticles'

export const Route = createFileRoute('/knowledge/$workspaceId/')({
  beforeLoad: async ({ params, context }) => {
    const articles = await context.queryClient.ensureQueryData(
      articlesQueryOptions(params.workspaceId),
    )
    if (articles.length > 0) {
      throw redirect({
        to: '/knowledge/$workspaceId/$articleId',
        params: { workspaceId: params.workspaceId, articleId: articles[0].id },
      })
    }
  },
  component: KnowledgeIndexFallback,
})

function KnowledgeIndexFallback() {
  return null
}
